import { MasterDatasetRunStatus, MasterDatasetSourceType, MasterDatasetType } from '../reporting/master-dataset.model';

export enum RegisterMasterDatasetUploadRequestKeys {
  datasetType = 'datasetType',
  sourceType = 'sourceType',
  reportDate = 'reportDate',
  uploadActionId = 'uploadActionId',
  sourceFileName = 'sourceFileName',
  sourceFilePath = 'sourceFilePath',
  sourceContentType = 'sourceContentType',
  sourceFileSize = 'sourceFileSize',
}

export interface RegisterMasterDatasetUploadRequest {
  [RegisterMasterDatasetUploadRequestKeys.datasetType]: MasterDatasetType;
  [RegisterMasterDatasetUploadRequestKeys.sourceType]?: MasterDatasetSourceType;
  [RegisterMasterDatasetUploadRequestKeys.reportDate]: string;
  [RegisterMasterDatasetUploadRequestKeys.uploadActionId]: string;
  [RegisterMasterDatasetUploadRequestKeys.sourceFileName]: string;
  [RegisterMasterDatasetUploadRequestKeys.sourceFilePath]: string;
  [RegisterMasterDatasetUploadRequestKeys.sourceContentType]: string;
  [RegisterMasterDatasetUploadRequestKeys.sourceFileSize]: number;
}

export interface RegisterMasterDatasetUploadResponse {
  runId: string;
  status: MasterDatasetRunStatus.Uploaded;
}
